/**
 * Badge - the small coloured pills used for statuses
 * --------------------------------------------------
 *   <Badge tone="green">Open</Badge>
 *   <StatusBadge status="assigned" />          for a chore
 *   <ApplicationBadge status="pending" />      for an application
 */

import { useI18n } from '../hooks/useI18n';

export default function Badge({ tone = 'grey', children, icon: Icon = null }) {
  return (
    <span className={`badge badge-${tone}`}>
      {Icon && <Icon size={12} aria-hidden="true" />}
      {children}
    </span>
  );
}

// Which colour goes with which chore status.
const CHORE_TONES = {
  open: 'green',
  assigned: 'blue',
  completed: 'soft-green',
  cancelled: 'grey',
  // Nobody applied and the day passed - see backend/utils/expiry.js.
  expired: 'grey',
};

export function StatusBadge({ status }) {
  const { t } = useI18n();
  // The stored status is the English enum; only the label is translated.
  return <Badge tone={CHORE_TONES[status] || 'grey'}>{t(`status.${status}`)}</Badge>;
}

// Which colour goes with which application status.
const APPLICATION_TONES = {
  pending: 'amber',
  accepted: 'green',
  backup: 'soft-blue',
  rejected: 'red',
  withdrawn: 'grey',
  // The chore itself went away - not something the student did.
  cancelled: 'grey',
};

export function ApplicationBadge({ status }) {
  const { t } = useI18n();
  return (
    <Badge tone={APPLICATION_TONES[status] || 'grey'}>
      {t(`applicationStatus.${status}`)}
    </Badge>
  );
}
